<template>
  <div class="finance-container">
    <template v-if="table_all_data.length != 0 && !spinShow">
      <div class="top">
        <div class="divider_line">
          <span>财务数据</span>
        </div>
        <div class="uplist">
          <Dropdown v-if="drop_list_length>1" class="drop" trigger="hover" placement="bottom-end" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
            <a href="javascript:void(0)">
              <span>{{drop_list[drop_name_val]}}</span>
              <Icon type="md-arrow-dropup" v-if="drop_icon_val" />
              <Icon type="md-arrow-dropdown" v-else />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem :name="key" v-for="item,key,index in drop_list" :key="key">{{item}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <p class="just-p" v-else>{{drop_list[drop_name_val]}}</p>
        </div>
      </div>
      <div class="tab-group1 tab-group">
        <div class="item" :class="{'active': tab1 == 'zcfzb'}" @click="changeTab1('zcfzb')">资产负债表</div>
        <div class="item" :class="{'active': tab1 == 'lrb'}" @click="changeTab1('lrb')">利润表</div>
        <div class="item" :class="{'active': tab1 == 'xjllb'}" @click="changeTab1('xjllb')">现金流量表</div>
      </div>
      <div class="tab-group2 tab-group">
        <div class="item" :class="{'active':  tab1_child[drop_name_val][tab1]['tab2'] == key}" v-for="item,key,index in tab1_child[drop_name_val][tab1]['tab_list']" :key="key" @click="changeTab2(key)">{{item}}</div>
        <Tooltip placement="top" content="当前数据较多，为方便浏览，您可按住鼠标左键并滑动可进行左右查看">
          <i class="iconfont">&#xe654;</i>
        </Tooltip>
        <div class="text">币种：{{drop_all_unit[drop_name_val]}}</div>
      </div>
      <!-- <div class="sticky">
            <table>
              <tr>
                <th width="238">{{tab1_child[drop_name_val][tab1]['table_header_title']}}</th>
                <th width="130" v-for="item,index in table_data" :key="index">{{dealTime(item)}}</th>
              </tr>
            </table>
          </div> -->
      <!-- <div class="table-title">
            <table>
              <th width="240">{{tab1_child[drop_name_val][tab1]['table_header_title']}}</th>
            </table>
          </div> -->
      <div class="table-group">
        <table class="table-row">
          <tr>
            <th width="240">{{tab1_child[drop_name_val][tab1]['table_header_title']}}</th>
          </tr>
          <tr v-for="item,index in tab1_child[drop_name_val][tab1]['table_row']" :key="index">
            <td :colspan="!item.name ? table_data.length+1:1" :class="{'colspan': !item.name}">{{item.value}}</td>
          </tr>
        </table>
        <div class="table-div">
          <table>
            <tr>
              <th width="238">{{tab1_child[drop_name_val][tab1]['table_header_title']}}</th>
              <th width="130" v-for="item,index in table_data" :key="index">{{dealTime(item)}}</th>
            </tr>
            <tr v-for="item,index in tab1_child[drop_name_val][tab1]['table_row']" :key="index">
              <td :colspan="!item.name ? table_data.length+1:1" :class="{'colspan': !item.name}">{{item.value}}</td>
              <template v-if="item.name">
                <td v-for="td,tindex in table_data" :key="tindex">{{td[item.name]===''?'--':td[item.name]}}</td>
              </template>
            </tr>
          </table>
        </div>
      </div>
    </template>
    <Nothing v-if="table_all_data.length == 0 && !spinShow">
      <p>暂无相关财务数据</p>
    </Nothing>
    <Spin fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>
<script>
let table_div = ''
let sticky_div = ''
// 判断鼠标是否按下
let isMouseDown = false
// 记录Y轴滚动距离
let scrollTop = 0
// 记录X轴滚动距离
let scrollLeft = 0
// 记录鼠标落点X坐标
let startX = 0
// 记录鼠标落点Y坐标
let startY = 0
import { getEntityFinanceData } from '../../../service'
import Nothing from '@/components/Nothing2'
export default {
  data() {
    return {
      spinShow: true,
      drop_icon_val: false,
      params: {
        uid: this.$route.params.uid,
      },
      drop_list_length: 0,
      drop_list: {},
      drop_all_list: {
        ganggu: '港股',
        hushen: '沪深',
        meigu: '美股',
      },
      drop_all_unit: {
        ganggu: '港元',
        hushen: '人民币',
        meigu: '美元',
      },
      drop_name_val: 'ganggu',

      tab1: 'zcfzb',
      tab1_child: {
        ganggu: {
          zcfzb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
            },
            tab2: '1',
            table_header_title: '截止日期',
            table_row: [
              { name: '', value: '流动资产（元）' },
              { name: 'xjjxjdjw', value: '现金及现金等价物' },
              {
                name: 'ygyjzjlqqbdjrdqsydjrzc(ld)',
                value: '以公允价值计量且其变动计入当期损益的金融资产（流动）',
              },
              { name: 'yszkjpj', value: '应收款帐及票据' },
              { name: 'ch', value: '存货' },
              { name: 'ldzcqtxm', value: '流动资产其他项目' },
              { name: 'ldzchj', value: '流动资产合计' },
              { name: '', value: '非流动资产（元）' },
              { name: 'wy、cfjsb', value: '物业、厂房及设备' },
              { name: 'syjwxzc', value: '商誉及无形资产' },
              { name: 'tdsyq', value: '土地使用权' },
              { name: 'qz:sy', value: '其中:商誉' },
              { name: 'wxzc|3', value: '无形资产' },
              {
                name: 'ygyjzjlqqbdjrdqsydjrzc(fld)',
                value: '以公允价值计量且变动计入当期损益的金融资产（非流动）',
              },
              { name: 'fldzcqtxm', value: '非流动资产其他项目' },
              { name: 'fldzchj', value: '非流动资产合计' },
              { name: 'zcze|1', value: '资产总额（元）' },
              { name: '', value: '流动负债（元）' },
              { name: 'dqjk', value: '短期借款' },
              { name: 'yfzkjpj', value: '应付账款及票据' },
              { name: 'ldfzqtxm', value: '流动负债其他项目' },
              { name: 'ldfzhj', value: '流动负债合计' },
              { name: '', value: '非流动负债（元）' },
              { name: 'rzzrfz(fld)', value: '融资租赁负债（非流动）' },
              { name: 'fldfzqtxm', value: '非流动负债其他项目' },
              { name: 'fldfzhj', value: '非流动负债合计' },
              { name: 'fzze|1', value: '负债合计' },
              { name: '', value: '股东权益也叫所有者权益' },
              { name: 'cb', value: '储备' },
              { name: 'lcsy|3', value: '留存收益' },
              { name: 'qtcb|3', value: '其他储备' },
              { name: 'gsymgsgdqyqtxm', value: '归属于母公司股东权益其他项目' },
              { name: 'gsymgsgdqy', value: '归属于母公司股东权益' },
              { name: 'fkgqy', value: '非控股权益' },
              { name: 'gdqyhj', value: '股东权益合计' },
              { name: 'fzjgdqyhj|1', value: '负债及股东权益合计（元）' },
            ],
          },
          lrb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
            },
            tab2: '1',
            table_header_title: '截止日期',
            table_row: [
              { name: 'yysr(js)', value: '营业收入（计算）' },
              { name: 'xscb', value: '销售成本' },
              { name: 'ml(js)', value: '毛利（计算）' },
              { name: 'qtsr', value: '其他收入' },
              { name: 'xsjfxcb', value: '销售及分销成本' },
              { name: 'xzkz', value: '行政开支' },
              { name: 'cwcb', value: '财务成本' },
              { name: 'sqlr', value: '税前利润' },
              { name: 'sds', value: '所得税' },
              { name: 'jlr', value: '净利润' },
              { name: 'bgsyyryzjlr|2', value: '本公司拥有人应占净利润' },
              { name: 'jbmgsy|2', value: '基本每股收益' },
              { name: 'xsmgsy|2', value: '稀释每股收益' },
              { name: 'qtqmsy', value: '其他全面收益' },
              { name: 'qmsyze', value: '全面收益总额' },
              { name: 'bgsyyryzqmsyze|2', value: '本公司拥有人应占全面收益总额' },
              { name: 'fkgqyyzqmsyze|2', value: '非控股权益应占全面收益总额' },
            ],
          },
          xjllb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
            },
            tab2: '1',
            table_header_title: '截止日期',
            table_row: [
              { name: '', value: '经营活动产生的现金流量（元）' },
              { name: 'zjytx', value: '折旧与摊销' },
              { name: 'jyhdcsdxjllje', value: '经营活动产生的现金流量净额' },
              { name: '', value: '投资活动产生的现金流量（元）' },
              { name: 'tzhdcsdxjllje', value: '投资活动产生的现金流量净额' },
              { name: '', value: '融资活动产生的现金流量（元）' },
              { name: 'xzjk', value: '新增借款' },
              { name: 'chjk', value: '偿还借款' },
              { name: 'fxgf', value: '发行股份' },
              { name: 'hggf', value: '回购股份' },
              { name: 'fxzq', value: '发行债券' },
              { name: 'rzhdcsdxjllje', value: '融资活动产生的现金流量净额' },
              { name: 'xjjxjdjwjzje|1', value: '现金及现金等价物净增加额（元）' },
              { name: 'xjjxjdjwdqcye|1', value: '现金及现金等价物的期初余额（元）' },
              { name: 'xjjxjdjwdqmyeqtxm|1', value: '现金及现金等价物的期末余额其他项目（元）' },
              { name: 'xjjxjdjwdqmye|1', value: '现金及现金等价物的期末余额（元）' },
            ],
          },
        },
        hushen: {
          zcfzb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
              //   '3': '报告期同比',
              //   '4': '年度同比'
            },
            tab2: '1',
            table_header_title: '资产负债表',
            table_row: [
              { name: '', value: '流动资产' },
              { name: 'hbzj', value: '货币资金' },
              { name: 'yspjjyszk', value: '应收票据及应收账款' },
              { name: 'qzyspj', value: '其中:应收票据' },
              { name: 'yszk', value: '应收账款' },
              { name: 'qtyskhj', value: '其他应收款合计' },
              { name: 'qtysk', value: '其他应收款' },
              { name: 'ynndqdfldzc', value: '一年内到期的非流动资产' },
              { name: 'qtldzc', value: '其他流动资产' },
              { name: 'ldzchj', value: '流动资产合计' },
              { name: '', value: '非流动资产' },
              { name: 'gdzc', value: '固定资产' },
              { name: 'wxzc', value: '无形资产' },
              { name: 'sy', value: '商誉' },
              { name: 'fldzchj', value: '非流动资产合计' },
              { name: 'zczj', value: '资产总计' },
              { name: '', value: '流动负债' },
              { name: 'dqjk', value: '短期借款' },
              { name: 'yspjjyszk', value: '应收票据及应收账款' },
              { name: 'qzyspj', value: '其中:应收票据' },
              { name: 'yszk', value: '应收账款' },
              { name: 'yfzgxc', value: '应付职工薪酬' },
              { name: 'ldfzhj', value: '流动负债合计' },
              { name: '', value: '非流动负债' },
              { name: 'cqjk', value: '长期借款' },
              { name: 'qtfldfz', value: '其他非流动负债' },
              { name: 'fzhj', value: '负债合计' },
              { name: '', value: '所有者权益（或股东权益）' },
              { name: 'gsymgsgdqyhj', value: '归属于母公司股东权益合计' },
              { name: 'gdqyhj', value: '股东权益合计' },
              { name: 'fzhgdqyhz', value: '负债和股东权益合计' },
            ],
          },
          lrb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
              3: '按单季度',
              //   '4': '报告期同比',
              //   '5': '年度同比',
              //   '6': '单季度环比',
            },
            tab2: '1',
            table_header_title: '利润表',
            table_row: [
              { name: 'yyzsr', value: '营业总收入' },
              { name: 'yysr', value: '营业收入' },
              { name: 'yycb', value: '营业成本' },
              { name: 'yffy', value: '研发费用' },
              { name: 'yysjjfj', value: '营业税金及附加' },
              { name: 'xsfy', value: '销售费用' },
              { name: 'glfy', value: '管理费用' },
              { name: 'cwfy', value: '财务费用' },
              { name: 'zcjzss', value: '资产减值损失' },
              { name: '', value: '其他经营收益' },
              { name: 'yylr', value: '营业利润' },
              { name: 'jyywsr', value: '加:营业外收入' },
              { name: 'jyywzc', value: '减:营业外支出' },
              { name: 'lrze', value: '利润总额' },
              { name: 'jsdsfy', value: '减:所得税费用' },
              { name: 'jlr', value: '净利润' },
              { name: 'qzgsymgsgddjlr', value: '其中:归属于母公司股东的净利润' },
              { name: '', value: '每股收益' },
              { name: 'jbmgsy', value: '基本每股收益' },
              { name: 'xsmgsy', value: '稀释每股收益' },
              { name: 'qtzhsy', value: '其他综合收益' },
              { name: 'gsymgsgddqtzhsy', value: '归属于母公司股东的其他综合收益' },
              { name: 'zhsyze', value: '综合收益总额' },
              { name: 'gsymgssyzdzhsyze', value: '归属于母公司所有者的综合收益总额' },
              { name: 'gsyssgddzhsyze', value: '归属于少数股东的综合收益总额' },
            ],
          },
          xjllb: {
            tab_list: {
              1: '按报告期',
              2: '按年度',
              3: '按单季度',
              //   '4': '报告期同比',
              //   '5': '年度同比',
              //   '6': '单季度环比',
            },
            tab2: '1',
            table_header_title: '现金流量表',
            table_row: [
              { name: '', value: '经营活动产生的现金流量' },
              { name: 'jjhdcsdxjllje', value: '经营活动产生的现金流量净额' },
              { name: '', value: '投资活动产生的现金流量' },
              { name: 'tzhdcsdxjllje', value: '投资活动产生的现金流量净额' },
              { name: '', value: '筹资活动产生的现金流量' },
              { name: 'xstzsddxj', value: '吸收投资收到的现金' },
              { name: 'qdjksddxj', value: '取得借款收到的现金' },
              { name: 'fxzqsddxj', value: '发行债券收到的现金' },
              { name: 'chzwzfdxj', value: '偿还债务支付的现金' },
              { name: 'czhdcsdxjllje', value: '筹资活动产生的现金流量净额' },
              { name: 'xjjxjdjwjzje', value: '现金及现金等价物净增加额' },
              { name: 'jqcxjjxjdjwye', value: '加:期初现金及现金等价物余额' },
              { name: 'qmxjjxjdjwye', value: '期末现金及现金等价物余额' },
            ],
          },
        },
        meigu: {
          zcfzb: {
            tab_list: {
              1: '全部',
              2: '年报',
              3: '单季报',
              //   '4': '累计季报'
            },
            tab2: '1',
            table_header_title: '报表日期',
            table_row: [
              { name: 'njr', value: '年结日' },
              { name: 'bz', value: '币种' },
              { name: '', value: '流动资产' },
              { name: 'xjjxjdjw', value: '现金及现金等价物' },
              { name: 'yszk', value: '应收账款' },
              { name: 'yspjld', value: '应收票据（流动）' },
              { name: 'ch', value: '存货' },
              { name: 'cyzdqtzld', value: '持有至到期投资（流动）' },
              { name: 'qtldzc', value: '其他流动资产' },
              { name: 'qtysk', value: '其他应收款' },
              { name: 'ldzcqtxm', value: '流动资产其他项目' },
              { name: 'ldzchj', value: '流动资产合计' },
              { name: '', value: '非流动资产' },
              { name: 'wycfjsb', value: '物业、厂房及设备' },
              { name: 'gdzc', value: '固定资产' },
              { name: 'wxzc', value: '无形资产' },
              { name: 'sy', value: '商誉' },
              { name: 'tdsyq', value: '土地使用权' },
              { name: 'cyzdqtzfld', value: '持有至到期投资（非流动）' },
              { name: 'fldzcqtxm', value: '非流动资产其他项目' },
              { name: 'fldzchj', value: '非流动资产合计' },
              { name: 'zzc', value: '总资产' },
              { name: '', value: '流动负债' },
              { name: 'yfzk', value: '应付账款' },
              { name: 'yfpjld', value: '应付票据（流动）' },
              { name: 'yfsxld', value: '应付税项（流动）' },
              { name: 'qtyfkjyjfy', value: '其他应付款及应计费用' },
              { name: 'dqzw', value: '短期债务' },
              { name: 'cqfzbqbf', value: '长期负债（本期部分）' },
              { name: 'dysrld', value: '递延收入（流动）' },
              { name: 'yfxchfl', value: '应付薪酬和福利' },
              { name: 'ldfzqtxm', value: '流动负债其他项目' },
              { name: 'ldfzhj', value: '流动负债合计' },
              { name: '', value: '非流动负债' },
              { name: 'cqfz', value: '长期负债' },
              { name: 'qtfldfz', value: '其他非流动负债' },
              { name: 'fldfzhj', value: '非流动负债合计' },
              { name: 'zfz', value: '总负债' },
              { name: 'zbjcb', value: '资本及储备' },
              { name: 'kcg', value: '库存股' },
              { name: 'lcsy', value: '留存收益' },
              { name: 'qtcb', value: '其他储备' },
              { name: 'gsymgsgdqyqtxm', value: '归属于母公司股东权益其他项目' },
              { name: 'gsymgsgdqy', value: '归属于母公司股东权益' },
              { name: 'gdqyhj', value: '股东权益合计' },
              { name: 'fzjgdqyhj', value: '负债及股东权益合计' },
              { name: 'kjzz', value: '会计准则' },
            ],
          },
          lrb: {
            tab_list: {
              1: '全部',
              2: '年报',
              3: '单季报',
              //   '4': '累计季报'
            },
            tab2: '1',
            table_header_title: '报表日期',
            table_row: [
              { name: 'cblx', value: '财报类型' },
              { name: 'njr', value: '年结日' },
              { name: 'bz', value: '币种' },
              { name: '', value: '收入' },
              { name: 'zysr', value: '主营收入' },
              { name: 'qtywsr', value: '其他业务收入' },
              { name: 'yysr', value: '营业收入' },
              { name: '', value: '成本' },
              { name: 'zycb', value: '主营成本' },
              { name: 'qtywcb', value: '其他业务成本' },
              { name: 'yycb', value: '营业成本' },
              { name: '', value: '经营费用' },
              { name: 'yffy', value: '研发费用' },
              { name: 'yxfy', value: '营销费用' },
              { name: 'ybjxzfy', value: '一般及行政费用' },
              { name: 'zjytx', value: '折旧与摊销' },
              { name: 'jzjbb', value: '减值及拨备' },
              { name: 'qtyyfy', value: '其他营业费用' },
              { name: 'czfy', value: '重组费用' },
              { name: 'yyfy', value: '营业费用' },
              { name: 'qtsy', value: '其他收益' },
              { name: 'yylr', value: '营业利润' },
              { name: '', value: '税前溢利' },
              { name: 'cxjysqlr', value: '持续经营税前利润' },
              { name: 'sds', value: '所得税' },
              { name: 'jlr', value: '净利润' },
              { name: 'gsyptggdjlr', value: '归属于普通股股东净利润' },
              { name: 'gsymgsgdjlr', value: '归属于母公司股东净利润' },
              { name: '', value: '每股指标' },
              { name: 'jbmgsyptg', value: '基本每股收益-普通股' },
              { name: 'tbmgsyptg', value: '摊薄每股收益-普通股' },
              { name: 'jbmgsyads', value: '基本每股收益-ADS' },
              { name: 'tbmgsyads', value: '摊薄每股收益-ADS' },
              { name: '', value: '全面收益' },
              { name: 'kjzz', value: '会计准则' },
            ],
          },
          xjllb: {
            tab_list: {
              1: '全部',
              2: '年报',
              3: '单季报',
              //   '4': '累计季报'
            },
            tab2: '1',
            table_header_title: '报表日期',
            table_row: [
              { name: 'njr', value: '年结日' },
              { name: 'bz', value: '币种' },
              { name: 'jyyw', value: '经营业务' },
              { name: 'jyhdcsdxjllje', value: '经营活动产生的现金流量净额' },
              { name: '', value: '投资业务' },
              { name: 'tzhdcsdxjllje', value: '投资活动产生的现金流量净额' },
              { name: '', value: '筹资业务' },
              { name: 'fxgf', value: '发行股份' },
              { name: 'hggf', value: '回购股份' },
              { name: 'fxzq', value: '发行债券' },
              { name: 'xzjk', value: '新增借款' },
              { name: 'chjk', value: '偿还借款' },
              { name: 'czhdcsdxjllje', value: '筹资活动产生的现金流量净额' },
              { name: 'xjjxjdjwzjjse', value: '现金及现金等价物增加（减少）额' },
              { name: 'xjjxjdjwqcye', value: '现金及现金等价物期初余额' },
              { name: 'kjzz', value: '会计准则' },
            ],
          },
        },
      },
      table_all_data: {},
      table_data: [],
    }
  },
  components: {
    Nothing,
  },
  methods: {
    async getDetail() {
      let res = await getEntityFinanceData(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.spinShow = false
      if (res.status == 'success') {
        if (res.res.length == 0) {
          this.table_all_data = res.res
          return
        }
        this.$emit('callbackData', 'Finance')
        Object.keys(res.res).forEach((item, index) => {
          if (index == 0) {
            this.drop_name_val = item
          }
          this.drop_list[item] = this.drop_all_list[item]
          this.drop_list_length += 1
        })
        this.table_all_data = res.res
        this.table_data = res.res[this.drop_name_val][this.tab1].filter((item) => {
          return item.type == this.tab1_child[this.drop_name_val][this.tab1]['tab2']
        })
        this.setHtml()
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {
        this.spinShow = false
      })
    },
    handleDropdown(val) {
      this.drop_icon_val = val
    },
    haddleScreenDropdown(name) {
      this.drop_name_val = name
      this.tab1 = 'zcfzb'
      this.changeTableData()
    },
    changeTab1(key) {
      this.tab1 = key
      this.changeTableData()
    },
    changeTab2(key) {
      this.tab1_child[this.drop_name_val][this.tab1]['tab2'] = key
      this.changeTableData()
    },
    changeTableData() {
      this.table_data = this.table_all_data[this.drop_name_val][this.tab1].filter((item) => {
        return item.type == this.tab1_child[this.drop_name_val][this.tab1]['tab2']
      })
    },
    dealTime(item) {
      if ('jzrq' in item) {
        return item.jzrq
      } else if ('reportdate' in item) {
        return moment(item.reportdate).format('YYYY-MM-DD').substring(2)
      } else if ('bbjzr' in item) {
        return item.bbjzr.substring(2)
      }
    },
    setHtml() {
      this.$nextTick(() => {
        table_div = document.querySelector('.table-div')
        // sticky_div = document.querySelector('.sticky')
        table_div.addEventListener('mousedown', (e) => {
          // 修改按下状态
          isMouseDown = true
          // 记录按下鼠标的位置, 用于计算鼠标的移动距离
          startX = e.offsetX
          startY = e.offsetY
        })
        table_div.addEventListener('mousemove', (e) => {
          // 判断鼠标移动时是否处于按下状态
          if (isMouseDown) {
            // 获取鼠标按下后移动的距离
            let offsetX = e.offsetX - startX
            let offsetY = e.offsetY - startY
            // PS: 需要注意的是当鼠标向上移动时, 滚动条应该向下移动, 所以这里都是减去的移动距离
            scrollTop = scrollTop - offsetY
            scrollLeft = scrollLeft - offsetX
            // 横向可移动的最大距离
            let limitX = table_div.scrollWidth - table_div.offsetWidth
            // 纵向可移动的最大距离
            let limitY = table_div.scrollHeight - table_div.offsetHeight
            if (scrollTop >= limitY) {
              // 当滑块移动到底端时
              scrollTop = limitY
            } else if (scrollTop <= 0) {
              // 当滑块移动到顶端时
              scrollTop = 0
            }

            if (scrollLeft >= limitX) {
              // 当滑块移动到左侧时
              scrollLeft = limitX
            } else if (scrollLeft <= 0) {
              // 当滑块移动到右侧时
              scrollLeft = 0
            }

            // 将计算后的距离赋值给滚动条
            table_div.scrollTop = scrollTop
            table_div.scrollLeft = scrollLeft
            // sticky_div.scrollTop = scrollTop
            // sticky_div.scrollLeft = scrollLeft
          }
        })
        table_div.addEventListener('mouseup', () => {
          isMouseDown = false
        })
      })
    },
  },
  created() {},
  mounted() {
    this.getDetail()
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.divider_line
  margin 40px 0
  position relative
  .drop
    position absolute
    right 0
    top -10px
.finance-container
  padding 0 32px 32px
  .top
    display flex
  .divider_line
    flex 1
    margin 32px 0 32px
  .uplist
    flex 0 0 auto
    margin-top 34px
    margin-left 10px
    .just-p
      color #fa7a50
  >>> .ivu-select-dropdown
    commonBgColor(#2D2F34, #fff)
    commonShadow(0 4px 20px 0 rgba(0, 0, 0, 0.5), 2px 4px 20px 0px rgba(121, 133, 143, 0.2))
    border-radius 0
    .ivu-dropdown-menu
      .ivu-dropdown-item
        commonColor(rgba(255, 255, 255, 0.9), #666)
      .ivu-dropdown-item-selected, .ivu-dropdown-item.ivu-dropdown-item-selected:hover
        color rgba(250, 122, 80, 1) !important
        commonBgColor(#35383F, #f9f9f9)
      .ivu-dropdown-item-selected, .ivu-dropdown-item-selected:hover
        color rgba(250, 122, 80, 1) !important
      .ivu-dropdown-item:hover
        commonBgColor(#35383F, #f9f9f9)
  .tab-group
    display flex
    align-items center
    position relative
    &1
      margin-left 18px
      border-bottom-width 1px
      border-bottom-style solid
      commonBorderColor(#40444f, #E9E9E9)
      .item
        padding 10px 22px
        font-size 16px
        commonColor(#BCBDC1, #666666)
        cursor pointer
        &.active
          border-bottom 1px solid #FA7A50
          color #FA7A50
        &:hover
          color #FA7A50
    &2
      padding-left 18px
      margin 20px 0 16px
      .item
        padding 4px 12px
        line-height 20px
        commonColor(#BCBDC1, #999999)
        commonBgColor(#2A2F42, #F3F3F3)
        cursor pointer
        &.active
          color #fff !important
          background #FA7A50
        &:hover
          color #FA7A50
      .text
        position absolute
        right 0
        top 6px
        commonColor(#BCBDC1, #666)
        font-size 14px
      .ivu-tooltip
        display inline-block
        vertical-align top
        margin 0 0 0 10px
        cursor pointer
        i
          color #ccc
        >>> .ivu-tooltip-arrow
          border-top-color #404040
        >>> .ivu-tooltip-inner
          background-color #404040
          max-width 1000px
        &:hover
          commonShadow(2px 4px 20px 0px rgba(0, 0, 0, 0.2), 2px 4px 20px 0px rgba(121, 133, 143, 0.1))
          i
            color #FA7A50
  .table-group
    position relative
    border-right-width 1px
    border-right-style solid
    commonBorderRightColor(#333333, #E9E9E9)
    padding-left 18px
    // transform translateY(-92px)
    .table-div
      overflow-x auto
      width 100%
      &:active
        cursor move
      &::-webkit-scrollbar-thumb, &::-webkit-scrollbar
        height 4px
    .table-row
      position absolute
      top 1px
      left 18px
      border-spacing 0
      border-collapse collapse
      th, td
        border-left-style solid
        border-left-width 1px
        commonBorderLeftColor(#333333, #E9E9E9)
        border-bottom-style solid
        border-bottom-width 1px
        commonBorderBottomColor(#333333, #E9E9E9)
        box-shadow 2px 10px 30px -4px rgba(0, 0, 0, 0.1)
        &.colspan
          box-shadow none
  table
    width max-content
    border-spacing 1px
    border-collapse unset
    table-layout fixed
    commonBgColor(#414556, #E9E9E9)
    th
      commonColor(#E9E9EB, #333333)
      text-align center
      padding 15px
      font-size 14px
      commonBgColor(#2A2F42, #FFFAF5)
      font-weight bold
      &:nth-child(1)
        padding 15px 20px
        text-align left
    td
      commonColor(#BCBDC1, #666)
      padding 10px 20px
      commonBgColor(#323646, #fff)
      text-align right
      font-size 13px
      line-height 20px
      &:nth-child(1)
        padding 10px 28px
        text-align left
        &.colspan
          padding 10px 20px
          commonColor(#E9E9EB, #333333)
          font-weight bold
  .sticky
    // border-right 1px solid #E9E9E9
    border-right-width 1px
    border-right-style solid
    commonBorderRightColor(#333333, #E9E9E9)
    overflow-x auto
    width calc(100% - 18px)
    position sticky
    top 0
    left 0
    margin-left 18px
    z-index 2
  .table-title
    position sticky
    top 46px
    left 0
    padding-left 18px
    z-index 3
    transform translateY(-46px)
    th
      // border-right 1px solid #E9E9E9
      border-right-width 1px
      border-right-style solid
      commonBorderRightColor(#333333, #E9E9E9)
      // box-shadow 2px 2px 10px -2px rgba(0, 0, 0, 0.2)
  .sticky, .table-div
    &::-webkit-scrollbar-thumb
      height 0
    &::-webkit-scrollbar
      height 0
</style>